module.exports = __webpack_public_path__ + "fonts/Barlow-Thin.905a17fa.woff2";